import * as React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon";

const Twitter: React.FC<IconPresentationProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={23}
            height={20}
            viewBox="0 0 23 20"
            fill="none"
        >
            <path
                d="M17.528.25h3.31l-7.229 8.26 8.504 11.24h-6.657l-5.217-6.816-5.962 6.816H.963l7.73-8.836L.54.25h6.825l4.71 6.23L17.529.25zm-1.162 17.522h1.833L6.367 2.125H4.4l11.967 15.647z"
                fill="#00A8FF"
            />
        </svg>
    );
};

export default React.memo(Twitter);
